var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { ComponentFeature, FilteringOperation } from '../internal';
var TokenHandler = /** @class */ (function () {
    function TokenHandler(component) {
        this.__component = component;
    }
    TokenHandler.prototype.addToken = function (token) {
        var newData = this.__component.__getData();
        newData.tokens = __spreadArrays(newData.tokens, [token]);
        this.__component.__controller.processComponentChange(ComponentFeature.PROPERTY_FILTERING, newData, true);
    };
    TokenHandler.prototype.addPropertyToken = function (selectedOption) {
        var token = {
            propertyKey: selectedOption.propertyKey,
            propertyLabel: selectedOption.propertyLabel,
            value: selectedOption.value,
            label: selectedOption.label,
            negated: false
        };
        this.addToken(token);
    };
    TokenHandler.prototype.addFreeTextToken = function (value, currentProperty) {
        // just free text
        var propertyKey = null;
        var propertyLabel = null;
        // prop is selected but value is free text
        if (currentProperty) {
            propertyKey = currentProperty.propertyKey;
            propertyLabel = currentProperty.propertyLabel;
        }
        var token = {
            propertyKey: propertyKey,
            propertyLabel: propertyLabel,
            value: value,
            label: "\"" + value + "\"",
            negated: false,
            isFreeText: true
        };
        this.addToken(token);
    };
    TokenHandler.prototype.updateFilterToken = function (dropdownId, token, dropdownItems) {
        var newData = this.__component.__getData();
        var tokens = newData.tokens.slice();
        var tokenIndex = tokens.indexOf(token);
        var item = dropdownItems.filter(function (dropdownItem) { return dropdownItem.id === dropdownId; })[0];
        tokens[tokenIndex] = __assign(__assign({}, token), { negated: item.negated });
        newData.tokens = tokens;
        newData.operation = item.operation;
        this.__component.__controller.processComponentChange(ComponentFeature.PROPERTY_FILTERING, newData, true);
    };
    TokenHandler.prototype.removeFilterToken = function (itemIndex) {
        var newData = this.__component.__getData();
        newData.tokens = __spreadArrays(newData.tokens.slice(0, itemIndex), newData.tokens.slice(itemIndex + 1));
        if (newData.tokens.length === 1) {
            newData.operation = FilteringOperation.AND;
            newData.tokens[0].negated = false;
        }
        this.__component.__controller.processComponentChange(ComponentFeature.PROPERTY_FILTERING, newData, true);
    };
    return TokenHandler;
}());
export default TokenHandler;
//# sourceMappingURL=token-handler.js.map